export const prepareTwoDMapData = (value) => (dispatch) => {
	return dispatch({
		type: "prepareTwoDMapData",
		payload: value
	});
};
export function downloadOnClick(value) {
	return (dispatch) => {
		dispatch({
			type: "downloadClick",
			payload: value
		});
	};
}

export function autoGeneratedPDF(value) {
	return (dispatch) => {
		dispatch({
			type: "autoGeneratedPDF",
			payload: value
		});
	};
}

export const generatedTwoDMapData = (value) => (dispatch) => {
	return dispatch({
		type: "generatedTwoDMapData",
		payload: value
	});
};
